import { Component, Input, OnInit } from '@angular/core';
import { MapService } from '../../services/map.service';

@Component({
  selector: 'ebw-monorepo-opacity-slider',
  templateUrl: './opacity-slider.component.html',
  styleUrls: ['./opacity-slider.component.scss']
})
export class OpacitySliderComponent implements OnInit {
  @Input() layerId: string;
  @Input() icon: boolean;

  public value: number = 1;

  constructor(private _mapService: MapService) {}

  ngOnInit(): void {
    this.value = this._mapService.getLayerOpacity(this.layerId);
  }

  onSliderChange(event: any) {
    this._mapService.setLayerOpacity(this.layerId, Number(event.target.value));
  }
}
